function responsiveSidebarCheck() {
	var sidebar = $('ul.dynamic-sidebar');
	var quick_links = $('.quick-links-accordion');
	var dynamic_sidebar_parent = $('ul.dynamic-sidebar .parent-page');

	// checks window width for proper active state
	if ($(window).width() < 782) {
		dynamic_sidebar_parent.removeClass('active').next('.subnav').stop().slideUp();
		$('.entry-content').prepend(sidebar).prepend(quick_links);
	} else {
		dynamic_sidebar_parent.removeClass('active').next('.subnav').stop().slideDown();
		$('.quick-links-accordion .accordion-item').removeClass('active').find('.copy').removeAttr('style');
		$('#dynamic-sidebar-anchor').prepend(sidebar);
		$('#quick-links-anchor').prepend(quick_links);
	}
}

$(document).ready(function () {
	// sidebar functionality
	if ($('ul.dynamic-sidebar').length) {
		var sidebar = $('ul.dynamic-sidebar');
		var dynamic_sidebar_parent = sidebar.find('.parent-page');

		dynamic_sidebar_parent.click(function () {
			if ($(window).width() < 782) {
				$(this).toggleClass('active');
				$(this).next('.subnav').stop().slideToggle();
			}
		});
    // plays with sidebar state
		$('li.page_item_has_children').click(function (e) {
			if (e.target !== e.currentTarget) return;
			$(this).toggleClass('active');
			$(this).find('> .children').stop().slideToggle();
		});
	}

	// accordion functionality
	var accordion = $('div.accordion');
	if (accordion.length) {
		accordion.find('.accordion-item.active .copy').stop().slideDown(0);
		$('div.accordion .accordion-item .trigger').click(function () {
			var currAcc = $(this).parent().parent().attr('id');
			var currItem = $(this).parent();
			var currCopy = $(this).next('.copy');

			$(currAcc).next('.accordion-item.active').not($(this)).removeClass('active');
			$(currAcc).next('.accordion-item .copy').not(currCopy).stop().slideUp();

			currItem.toggleClass('active');
			currCopy.stop().slideToggle();
		});
	}
});

$(window).bind('resize', function () {
  if ($('ul.dynamic-sidebar').length > -1) {
    responsiveSidebarCheck();
  }
}).trigger('resize');


$('#find-a-doctor').on($.modal.OPEN, function(event, modal) {
	$('#find-a-doctor').find('#search-input').focus();
  });

//Adds classes to details elements to support smooth transitions
  document.addEventListener("DOMContentLoaded", function () {
	const accordions = document.querySelectorAll("details.wp-block-details");
	//console.log(accordions);
	accordions.forEach(details => {
	  const summary = details.querySelector("summary");
	  const content = details.querySelector(".content");
  
	  // Set initial height to 0 if not open
	  if (!details.hasAttribute("open")) {
		content.style.height = "0px";
	  } else {
		details.classList.add("is-open");
		content.style.height = content.scrollHeight + "px";
	  }
  
	  summary.addEventListener("click", function (e) {
		e.preventDefault();
  
		// Close other accordions if needed (optional, remove if you want multiple open)
		// accordions.forEach(other => {
		//   if (other !== details) {
		//     other.removeAttribute("open");
		//     other.classList.remove("is-open");
		//     other.querySelector(".wp-block-group").style.height = "0px";
		//   }
		// });
  
		if (details.hasAttribute("open")) {
		  // Closing
		  content.style.height = content.scrollHeight + "px"; // set current height
		  requestAnimationFrame(() => {
			content.style.height = "0px";
		  });
		  details.classList.remove("is-open");
  
		  setTimeout(() => {
			details.removeAttribute("open");
		  }, 400); // match the CSS transition duration
		} else {
		  // Opening
		  details.setAttribute("open", "true");
		  content.style.height = content.scrollHeight + "px";
		  details.classList.add("is-open");
  
		  content.addEventListener("transitionend", function handler() {
			// After transition ends, remove the fixed height to allow natural height growth
			content.style.height = "auto";
			content.removeEventListener("transitionend", handler);
		  });
		}
	  });
	});
  });


    function onBackgroundImageLoad(element, callback) {
	
	const style = window.getComputedStyle(element);
	const backgroundImage = style.backgroundImage;

	// Extract URL from: url("...") or url('...')
	const match = backgroundImage.match(/url\(["']?(.+?)["']?\)/);
	if (!match) return;

	const url = match[1];
	const img = new Image();
	img.onload = callback;
	img.src = url;

	// Optional: handle error
	img.onerror = () => {
		console.warn('Background image failed to load:', url);
	};
	}
	const heroel = document.querySelector('page.home .home-hero .wp-block-cover__image-background');
		onBackgroundImageLoad(heroel, function () {
		console.log('Background image loaded');
	});
  
// ## EXIT MODAL / SPEED BUMP
// Warns visitors before leaving the site 
  jQuery(document).ready(function() {
	var allowedDomains = [
	  window.location.host,
	  'ecmc.edu',
	  'supportecmctrauma.org',
	  'synergybariatrics.com',
	  'healthcaresource.com',
	  'ecmc-health-campus.inquicker.com',
	  'ecmc-covid-vaccine.inquicker.com',
	  'inquicker.com',
	  'givesmart.com',
	  'give716.org',
	  'medentlink.com',
	  'medentmobile.com'
	];
  
	var skipPatterns = [
	  /^\/(?!\/)/,         // single leading slash (relative)
	  /^javascript:/i,     // javascript: links
	  /^tel:/i,            // telephone links
	  /^mailto:/i,          // email links
      /^#/  				// hash links
	];
  
	// 3. Click handler for external-link modal
	function handleExternalClick(event) {
	  event.preventDefault();
	  event.stopPropagation();
  
	  var targetUrl = this.href;
	  var inst = jQuery('#exit-site-modal').modal({fadeDuration: 200});
  
	  jQuery('#exit-site-modal .exit-confirm a')
		.off('click')
		.on('click', function() {
		  window.open(targetUrl, '_blank');
		  jQuery('#exit-site-modal').close();
		});
  
	  inst.open();
	}

	
	//Maybe
	//Fix
	// 4. Iterate all anchors, skip ones that match allow-list or skip patterns
	jQuery('a').each(function() {
	  var $link = jQuery(this);
	  var href = this.href;
	  var $egg = '';
  
	  // Skip if link has the 'fresco' class
	  if ($link.hasClass('fresco')) {
		return;
	  }
  
	  // Skip if href matches any skip pattern
	  for (var i = 0; i < skipPatterns.length; i++) {
		if (skipPatterns[i].test(href)) {
		  return;
		}
	  }
  
	  // Skip if href contains any allowed domain
	  for (i = 0; i < allowedDomains.length; i++) {
		if (href.indexOf(allowedDomains[i]) !== -1) {
		  return;
		}
	  }
	  $link.addClass('ext-link');

	  // Otherwise, bind our external-link modal
	  $link.off('click').on('click', handleExternalClick);
	});
  });

